import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=6c32032f&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=6c32032f&prod&lang=scss&scoped=true&"
import style1 from "./_slug.vue?vue&type=style&index=1&id=6c32032f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32032f",
  null
  
)

export default component.exports